export default __webpack_public_path__ + "static/media/mango_tree.947b224f.svg";